import React from "react";
import { useEffect, useState } from "react";
import { apiService } from "../utils/apiRequest";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import CircularProgress from "@mui/material/CircularProgress"; 
import {useDispatch, useSelector } from "react-redux";
import { setAppointmentFor, setNotes, setSessionDate, setSessionDuration, setSessionRemainingHour, setSessionStartTime,setSessionEndTime, setSessionStudent, setComment } from "../redux/actions/sessionActions";
import { addSchoolSession, resetSchoolSessions } from "../redux/actions/schoolsessionActions";
import {SessionDetails } from 'tutorapp-components'
import { resetUpcomingSessions } from "../redux/actions/upcomingSessionActions";
import { setSessiontype } from "../redux/actions/familyPresetValuesActions";
import { toast } from "react-toastify";
import { setNextDate } from "../redux/actions/sessionActions";


const SessionDetailsScreen = () => {


   const showCreateButton = useSelector((state) => state.session.showReportButton);

  const dispatch = useDispatch();  
    const userPreferences = useSelector((state) => state.userPreferences);
  
  const  receivedData  = useSelector((state) => state.session.appointmentId);
  const navigate = useNavigate();
  const [Loading , setLoading] = useState()
  const [sessiondetails ,setSessiondetails] = useState()
    const [studentNames, setStudentNames] = useState([]);
  

  const editicons = {
    general: "./images/ic_edit.svg",
    dateTime: "./images/ic_edit.svg",
    settings: "./images/ic_edit.svg",
    appointmentFor: "./images/ic_appointment.svg",
    subject: "./images/ic_subject.svg",
    enrollment: "./images/ic_enrollment.svg",
    students: "./images/ic_student.svg",
    remainingHours: "./images/ic_time.svg",
    date: "./images/ic_calendar.svg",
    time: "./images/ic_time.svg",
    sessionsPerWeek: "./images/ic_sessions_per_week.svg",
    sessionType: "./images/ic_online.svg",
    repeat: "./images/ic_repeat.svg",
    tutoringAddress: "./images/ic_tutoring_address.svg",
    backarrow: "./images/ic_back.svg",
    delete: "./images/ic_delete.svg",
  };

  const handleEditGeneral = () => {
    navigate("/editgeneral");
  };

  const ondelete = () => {
    console.log("deleteclick");
  };

  const handleDateTime = () => {
    navigate("/appointmentdate-time");
  };

  const handleSetting = () => {
    navigate("/appointmentsettings");
  };

  const handleCreateAppointment = () =>{

  //  dispatch(addSession(formattedData));
   dispatch(setSessiontype(sessiondetails?.sessions_type))
   dispatch(setSessionDate(sessiondetails?.appointment_date + ' '+ sessiondetails?.start_time))
   dispatch(setSessionStudent( sessiondetails?.students))
   dispatch(setAppointmentFor(sessiondetails?.appointment_for))
   dispatch(setSessionRemainingHour(sessiondetails?.remaining_hours))
   dispatch((setSessionDuration(calculateSessionDuration(sessiondetails?.start_time, sessiondetails?.end_time))))
   dispatch((setSessionStartTime(sessiondetails?.start_time)))
   dispatch((setSessionEndTime(sessiondetails?.end_time)))
   dispatch(setNextDate(sessiondetails?.next_session_date_time))
   dispatch(setComment(sessiondetails?.comment))
const cleanedNotes = (sessiondetails?.notes_c || '')
  .replace(/<br\s*\/?>/gi, '\n')
  .replace(/\n+/g, '\n\n') // double spacing
  .trim();

dispatch(setNotes(cleanedNotes));   

    if(sessiondetails?.appointment_for == "Schools"){
      dispatch(addSchoolSession({
        appointmentId: receivedData,
        student: sessiondetails.students
      }))
             navigate("/session-attandence")

      }
    else{
      navigate("/session-date-time")}
  }

  const onarrowclick = () => {
    dispatch(resetSchoolSessions())
    dispatch(resetUpcomingSessions())
    navigate("/reportlisting")

  }

  //api calling function for getting appointment details
 const AppointmentDetails = async (appointmentId) => {
  
    try {
      
      setLoading(true)
      const getAppointmentDetails = process.env.REACT_APP_API_URL + 'getAppointmentDetails'
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          appointment_id: appointmentId,
        }),
      };
  
      const response = await apiService(getAppointmentDetails, options);
  
      if (response.status == 'success') {
        // Optionally, refresh the appointments list
        setLoading(false)

        setSessiondetails(response.data)

        // setLoading(false)
      } else {
        console.error("Failed to reschedule appointment:", response.message);
      }
    } catch (error) {
      console.error("Error while rescheduling appointment:", error);
    }
    finally{
     setLoading(false)

    }
  };

  useEffect(() => {
    if (true) {
      AppointmentDetails(receivedData); // Pass appropriate data
    }
  }, [receivedData]); // Empty
  
  const calculateSessionDuration = (startTime, endTime) => {
    if (!startTime || !endTime) return null; // Handle cases where times are missing
  
    // Convert "HH:MM:SS" strings to minutes
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    const [endHours, endMinutes] = endTime.split(":").map(Number);
  
    // Convert to total minutes
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
  
    // Calculate duration in minutes
    return endTotalMinutes - startTotalMinutes;
  };

     //Data for creating session report
    const formattedData = {
       
      session_data: {
      session_date_time: sessiondetails?.appointment_date + ' '+ sessiondetails?.start_time,
      session_type: sessiondetails?.sessions_type,
      session_student: sessiondetails?.students,
      session_duration: calculateSessionDuration(sessiondetails?.start_time, sessiondetails?.end_time),
      session_remaininghour : sessiondetails?.remaining_hours,
      appointment_for : sessiondetails?.appointment_for
    }};

    const getStudentNames = async (studentIds) => {
          setLoading(true); // Start loading
          try {
            const endpoint = process.env.REACT_APP_API_URL + 'getStudentName';
            const options = {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ student_ids: studentIds }),
            };
      
            const response = await apiService(endpoint, options);
      
            if (response.status === 'success') {
              setStudentNames(response.data.valid_students);
           
      
            } else {
              toast.error(response.message || "Failed to fetch student names", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "dark",
                style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
              });
            }
          } catch (error) {
            console.error("Error fetching student names:", error);
            toast.error("An error occurred while fetching student names", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "dark",
              style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
            });
          } finally {
            setLoading(false); // Stop loading
          }
        };
    
    
        useEffect(() => {
      if (sessiondetails?.students?.length > 0) {
        getStudentNames(sessiondetails.students);
      }
    }, [sessiondetails]);


  return (
    <div className="d-flex flex-column min-vh-100">
    {Loading ? (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <CircularProgress style={{ color: 'black' }} />
      </div>
    ) : (
      <SessionDetails
        appointmentdata={sessiondetails}
        icons={editicons}
        handleSetting={handleSetting}
        handleDateTime={handleDateTime}
        handleEditGeneral={handleEditGeneral}
        ondelete={ondelete}
        onarrowclick={onarrowclick}
        onClose={handleCreateAppointment}
        userPreferences={userPreferences}
        showCreateButton ={showCreateButton}
        studentlist={studentNames}


      />
    )}
  </div>
  );
};

export default SessionDetailsScreen;
